export const blockIconsHardwareKeyboardArrowLeft = (
	<span className='material-symbols-outlined'>keyboard_arrow_left</span>
);
